var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteboardAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V3H4C2.89543 3 2 3.89543 2 5V14C2 15.1046 2.89543 16 4 16H11.25V17.6395L6.53148 21.4143C6.20803 21.6731 6.15559 22.1451 6.41435 22.4685C6.67311 22.792 7.14507 22.8444 7.46852 22.5857L11.25 19.5605V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V19.5605L16.5315 22.5857C16.8549 22.8444 17.3269 22.792 17.5857 22.4685C17.8444 22.1451 17.792 21.6731 17.4685 21.4143L12.75 17.6395V16H20C21.1046 16 22 15.1046 22 14V5C22 3.89543 21.1046 3 20 3H12.75V2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboardAlt1);
export default __webpack_public_path__ + "static/media/whiteboard-alt-1.b1cf42c2a8ccd1119b46df1cf8a92b01.svg";
export { ForwardRef as ReactComponent };